module.exports = __webpack_public_path__ + "img/ar.2dd9486f.svg";